import { useState, useEffect } from 'react';

const NAV_LINKS = [
  { label: 'Serviços', href: '#servicos' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'FAQ', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-400 ${
        scrolled
          ? 'bg-brand-dark border-b border-white/10'
          : 'bg-brand-dark border-b border-white/10'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 h-18 flex items-center justify-between" style={{ height: '72px' }}>
        {/* Logo */}
        <a href="#" className="cursor-pointer flex-shrink-0">
          <img
            src="https://cloud-1de12d.becdn.net/media/iW=263&iH=74&oX=0&oY=0&cW=262&cH=74/d9cb7c1a38d700abdcef0c923bf7c2e0/lgo-2.png"
            alt="Ariani Zanardo Advocacia"
            className="h-14 w-auto object-contain brightness-0 invert"
          />
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link.href)}
              className="whitespace-nowrap cursor-pointer font-inter text-sm font-medium text-white/70 hover:text-white transition-colors duration-200"
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* CTA */}
        <a
          href="https://api.whatsapp.com/send?phone=5551996057679&text=Ol%C3%A1,%20vim%20do%20seu%20site%20e%20gostaria%20de%20falar%20com%20um%20advogado."
          target="_blank"
          rel="noopener noreferrer"
          className="whitespace-nowrap cursor-pointer hidden md:inline-flex items-center gap-2 bg-brand-gold hover:bg-brand-gold-light text-white font-inter font-medium text-sm px-5 py-2.5 rounded-md transition-all duration-200"
        >
          <i className="ri-whatsapp-line text-base" />
          Falar com advogada
        </a>

        {/* Mobile menu toggle */}
        <button
          className="md:hidden cursor-pointer w-9 h-9 flex items-center justify-center"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-xl text-white`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-brand-dark border-t border-white/10 px-8 py-6 flex flex-col gap-4">
          {NAV_LINKS.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link.href)}
              className="whitespace-nowrap cursor-pointer font-inter text-sm text-white/70 hover:text-white text-left py-1 transition-colors duration-200"
            >
              {link.label}
            </button>
          ))}
          <a
            href="https://api.whatsapp.com/send?phone=5551996057679&text=Ol%C3%A1,%20vim%20do%20seu%20site%20e%20gostaria%20de%20falar%20com%20um%20advogado."
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-brand-gold hover:bg-brand-gold-light text-white font-inter font-medium text-sm px-5 py-3 rounded-md mt-2 justify-center"
          >
            <i className="ri-whatsapp-line text-base" />
            Falar com advogada
          </a>
        </div>
      )}
    </header>
  );
}
